var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCompany = function SvgCompany(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "company_svg2__a",
    x1: 13.27,
    x2: 212.95,
    y1: 192.2,
    y2: 21.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M189.29 46.43h-42.86V35.72c0-13.79-11.21-25-25-25H78.57c-13.79 0-25 11.21-25 25v10.71H10.71C4.82 46.43 0 51.25 0 57.14v121.43c0 5.89 4.82 10.71 10.71 10.71h178.57c5.89 0 10.71-4.82 10.71-10.71V57.14c0-5.89-4.82-10.71-10.71-10.71ZM60.71 35.71c0-9.86 8-17.86 17.86-17.86h42.86c9.86 0 17.86 8 17.86 17.86v10.71h-7.14V35.71c0-5.89-4.82-10.71-10.71-10.71H78.58c-5.89 0-10.71 4.82-10.71 10.71v10.71h-7.14V35.71ZM75 46.43V35.72c0-1.96 1.61-3.57 3.57-3.57h42.86c1.96 0 3.57 1.61 3.57 3.57v10.71zM7.14 57.14c0-1.96 1.61-3.57 3.57-3.57h178.57c1.96 0 3.57 1.61 3.57 3.57v46.43c0 5.89-4.82 10.71-10.71 10.71h-60.71v-7.14c0-3.93-3.21-7.14-7.14-7.14H85.72c-3.93 0-7.14 3.21-7.14 7.14v7.14H17.86c-5.89 0-10.71-4.82-10.71-10.71V57.14Zm107.15 71.43H85.72v-21.43h28.57v21.42Zm-21.43 7.14h14.29v7.14c0 3.93-3.21 7.14-7.14 7.14s-7.14-3.21-7.14-7.14v-7.14Zm96.43 46.43H10.71c-1.96 0-3.57-1.61-3.57-3.57v-60.82c3 2.25 6.68 3.68 10.71 3.68h60.71v7.14c0 3.93 3.21 7.14 7.14 7.14v7.14c0 7.89 6.39 14.29 14.29 14.29s14.29-6.39 14.29-14.29v-7.14c3.93 0 7.14-3.21 7.14-7.14v-7.14h60.71c4.04 0 7.71-1.39 10.71-3.68v60.82c0 1.96-1.61 3.57-3.57 3.57Z",
    style: {
      fill: "url(#company_svg2__a)",
      strokeWidth: 0
    }
  }));
};
export default SvgCompany;